import { TOTAL_HORSES, MIN_CONDITION, MAX_CONDITION, HORSE_NAMES, HORSE_COLORS } from '@/constants'
import { getRandomInt, shuffleArray } from '@/utils/helpers'

const state = () => ({
  horses: [],
  isGenerated: false
})

const getters = {
  allHorses: state => state.horses,
  getHorseById: state => id => state.horses.find(h => h.id === id),
  isHorsesGenerated: state => state.isGenerated,
  horsesCount: state => state.horses.length
}

const mutations = {
  SET_HORSES(state, horses) {
    state.horses = horses
    state.isGenerated = true
  },
  RESET_HORSES(state) {
    state.horses = []
    state.isGenerated = false
  }
}

const actions = {
  generateHorses({ commit }) {
    const names = shuffleArray(HORSE_NAMES)
    const colors = shuffleArray(HORSE_COLORS)
    
    const horses = []
    for (let i = 0; i < TOTAL_HORSES; i++) {
      horses.push({
        id: i + 1,
        name: names[i],
        condition: getRandomInt(MIN_CONDITION, MAX_CONDITION),
        color: colors[i]
      })
    }
    commit('SET_HORSES', horses)
  },
  resetHorses({ commit }) {
    commit('RESET_HORSES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
